import React, { useContext } from "react";

//Import components
import Socials from "./Socials";
import Logo from "../img/header/logo.svg";
import MobileNav from "./MobileNav";

import { Link } from "react-router-dom";
import { CursorContext } from "../context/CursorContext";

const Header = () => {
  const { mouseEnterHandler, mouseLeaveHandler } = useContext(CursorContext);

  return (
    <header className="fixed w-full px-[30px] lg:px-[100px] z-30 h-[100px] lg:h-[140px] flex items-center">
      <div className="flex flex-col lg:flex-row lg:items-center w-full justify-between">
        <Link
          onMouseEnter={mouseEnterHandler}
          onMouseLeave={mouseLeaveHandler}
          to={"/"}
          className="max-w-[200px]"
        >
          <h1>@mateuss.cardosoo</h1>
         
        </Link>

        {/* Navbar Desktop */}
        <nav
          onMouseEnter={mouseEnterHandler}
          onMouseLeave={mouseLeaveHandler}
          className="hidden xl:flex gap-x-12 font-semibold "
        >
          {/* Home */}
          <Link
            to={"/"}
            className="text-[#696c6d] hover:text-primary transation"
          >
            Home
          </Link>

          {/* About */}
          <Link
            to={"/about"}
            className="text-[#696c6d] hover:text-primary transation"
          >
            About
          </Link>
          {/* Portfolio */}
          <Link
            to={"/portfolio"}
            className="text-[#696c6d] hover:text-primary transation"
          >
            Portfolio
          </Link>
          {/* Contact */}
          <Link
            to={"/contact"}
            className="text-[#696c6d] hover:text-primary transation"
          >
            Contact
          </Link>
        </nav>
      </div>
      {/* Socials */}
      <Socials />

      {/* Navbar Mobile */}
      <MobileNav />
    </header>
  );
};

export default Header;
